import React, { PropsWithChildren } from 'react';
import { ThemeProvider as MUITheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { createThemeYH } from '@cp/ds';
import { themeNameSelector } from './reducer';

export const ThemeProvider = (
  props: PropsWithChildren<{
    ssrMatchMedia?: (query: string) => {
      matches: boolean;
    };
  }>,
) => {
  const themeName = useSelector(themeNameSelector);
  const theme = React.useMemo(() => createThemeYH(themeName, { ssrMatchMedia: props.ssrMatchMedia }), [props.ssrMatchMedia, themeName]);
  return <MUITheme theme={theme}>{props.children}</MUITheme>;
};
